// extracted by mini-css-extract-plugin
export default {"ficha":"FichaSolapas_ficha__dawLs","cabecera":"FichaSolapas_cabecera__GYvQX","contenedor":"FichaSolapas_contenedor__ArWPv","titulo":"FichaSolapas_titulo__owh7q"};